import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { PaymentFailedContainer } = await import('@containers/Payment/PaymentFailed');
    return {
        Component: PaymentFailedContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
